import { FieldInputProps, FormikProps } from 'formik';
import FormFieldMessage from '../../common/FormFieldMessage';
import Input from '../../common/Input';
import ValidationErrorSvg from '../../../assets/ValidationError.svg';
import './IntegerAnswer.css';

export type IntegerAnswerProps = {
  field: FieldInputProps<any>;
  form: (string | undefined) & FormikProps<any>;
  placeholderText: string;
  subText: string;
  formatAsCurrency?: boolean;
};

const IntegerAnswer = ({ field, form, placeholderText, subText, formatAsCurrency = false }: IntegerAnswerProps) => {
  const isInvalid = () => form.touched[field.name] && form.errors[field.name];
  return (
    <>
      <Input
        field={field}
        form={form}
        placeholder={placeholderText}
        type='text'
        digitsOnly={true}
        className='integer-answer'
        monetary={formatAsCurrency}
        suppressValidation={true}
      />
      {
        subText && 
          <div className='integer-answer-sub-integer-container'>
            <span className='integer-answer-sub-text'>{subText}</span>
          </div>
      }
      {
        isInvalid() && 
          <div className='question-answer-validation'>
            <img src={ValidationErrorSvg} alt='Validation' />
            <FormFieldMessage text={form.errors[field.name]} />
          </div>
      }
    </>
  );
};

export default IntegerAnswer;